import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "about-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "명사 사이에 물음표를 넣어주어 문장을 \"몰?루화\"해줍니다.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"gray"} }, [
  /*#__PURE__*/_createElementVNode("s", null, "프라나 사랑해")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "참고 사항"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "이 웹 서비스는 팬메이드 사이트로, 수익을 얻기 위해 운영하는 사이트가 아닙니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 이 웹 서비스는 게임 \"블루 아카이브\"의 개발사 및 유통/운영사와 전혀 무관한 사이트이며, 그러한 기업 또는 단체로부터 어떠한 형태로든 지원이나 지시를 받은 사실이 없습니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 사용자는 이 웹 서비스를 이용하는 순간부터, "),
    /*#__PURE__*/_createElementVNode("strong", null, "사용자가 받는 모든 불이익에 대해 개발자는 책임질 의무가 없음에 동의"),
    /*#__PURE__*/_createTextVNode("한 것으로 간주합니다."),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "크레딧", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "사용한 오픈 소스 라이브러리", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { style: {"display":"block","color":"slategray"} }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, " | ", -1)
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "이 웹 앱은 방문 통계 확인용으로 Google Analytics를 사용합니다. 사용자가 입력한 문장 및 기타 민감한 데이터는 서버에 저장하거나 Google 및 타 서비스에 공유하지 않습니다.", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", null, [
        _createTextVNode("몰?루파이어 "),
        _createElementVNode("small", null, "v" + _toDisplayString(_ctx.appVersion), 1)
      ]),
      _hoisted_2,
      _hoisted_3
    ]),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("div", null, [
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CREDITS, (credit) => {
        return (_openBlock(), _createElementBlock("p", {
          key: credit.description
        }, [
          _createElementVNode("span", null, _toDisplayString(credit.description) + " : ", 1),
          (credit.link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: credit.link,
                target: "_blank"
              }, _toDisplayString(credit.name), 9, _hoisted_8))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(credit.name), 1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(credit.subtitles, (subtitle) => {
            return (_openBlock(), _createElementBlock("small", {
              key: subtitle.text,
              style: {"display":"block","color":"slategray"}
            }, [
              _createElementVNode("span", null, _toDisplayString(subtitle.text), 1),
              (subtitle.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: subtitle.link,
                    target: "_blank"
                  }, _toDisplayString(subtitle.link), 9, _hoisted_10))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      }), 128))
    ]),
    _hoisted_11,
    _createElementVNode("div", null, [
      _hoisted_12,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPENSOURCES, (os) => {
        return (_openBlock(), _createElementBlock("p", {
          key: os.name
        }, [
          _createElementVNode("b", null, _toDisplayString(os.name), 1),
          (os.description)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " — " + _toDisplayString(os.description), 1))
            : _createCommentVNode("", true),
          _createElementVNode("small", _hoisted_14, [
            _createElementVNode("span", null, _toDisplayString(os.license), 1),
            _hoisted_15,
            _createElementVNode("a", {
              href: os.link.link,
              target: "_blank"
            }, _toDisplayString(os.link.name), 9, _hoisted_16)
          ])
        ]))
      }), 128))
    ]),
    (_ctx.isGAEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
      : _createCommentVNode("", true)
  ]))
}